import { render, staticRenderFns } from "./EditCarrier.vue?vue&type=template&id=45a91d7a&lang=pug&"
import script from "./EditCarrier.vue?vue&type=script&lang=js&"
export * from "./EditCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports